require('./sms-campaign-show.scss')

module.exports = {
  template: require('./sms-campaign-show.pug')()
  controller: require('./sms-campaign-show.ctrl')
  bindings:
    smsCampaign: '<'
}
